import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import BrandConfigurationOverview from "../../../../components/Partners/DataIntegrations/Brands/BrandConfigurationOverview/BrandConfigurationOverview";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  resetBrandConfigurationReportState,
  setIsSuccess,
  setProcessFailure,
} from "../../../../features/brandConfigurationReportSlice";

// Brand Overview, reached from the Brands module's "Brand Overview" quick
// action (operations/brands/...). BrandConfigurationOverview now lives under
// this module's own folder (moved, not duplicated, from the legacy
// BrandConfigurationReport module) — its own screen/route
// (BrandConfigurationOverviewScreen.tsx, operations/brand_configuration_report/...)
// still imports it from its new location and is otherwise untouched.
//
// The "Run Brand" button here opens the same reused RunBrandData.tsx wizard
// as the Brands tables, which dispatches its result into
// brandConfigurationReportSlice. The success/failure banners for that result
// are rendered by BrandConfigurationOverview itself (the legacy
// BrandConfigurationOverviewScreen.tsx relies on them too, and renders none
// of its own) — this screen must NOT render a second copy, or every Run Brand
// response shows twice on the Brands route.
const BrandOverviewScreen = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasBrandsPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "brands",
    "view_brands",
  );

  useEffect(() => {
    dispatch(setIsSuccess(false));
    dispatch(setProcessFailure({ isFailed: false, message: "" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetBrandConfigurationReportState());
    };
  }, [dispatch]);

  return (
    <>{hasBrandsPermission ? <BrandConfigurationOverview /> : <Page404 />}</>
  );
};

export default BrandOverviewScreen;
